<script>
  import converterMoeda from '~js/converter-moeda';
  import { checkbox } from 'vue-strap';

  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      removeErro(field) {
        var pos = -1;

        while (this.errors.has(field)) {
          for (var i = 0; i < this.errors.items.length; i++) {
            if (this.errors.items[i].field == field) {
              pos = i
              break
            }
          }

          if (pos > -1) {
            this.errors.items.splice(pos, 1)
          }
        }
      },
      removeErroAceite() {
        this.removeErro('aceite');
      },
      adicionaErroAceite() {
        if (!this.errors.has('aceite')) {
          this.errors.items.push(
            { "id": "_y980569955l9f3565sd", "field": "aceite", "msg": "É obrigatório aceitar o custo total acima", "rule": "required", "scope": null }
          )
        }
      },
      retornaBC() {
        const tipo = this.$options.filters.formatarNumero(this.solicitacao.tipoSolicitacao, true);

        return tipo == 1 ? 'C' : 'B'; 
      },
      retornaCD() {
        const tipo = this.$options.filters.formatarNumero(this.solicitacao.tipoSolicitacao, true);

        return tipo == 1 ? 'D' : 'C'; 
      }
    },
    mounted() {

    },
    computed: {
      valorSalarioBruto: function() {
        const valor = this.$options.filters.formatarNumero(this.solicitacao.salarioBruto, true);

        return valor
      },
      percentualEncargo: function () {
        const perc = this.$options.filters.formatarNumero(this.solicitacao.percentualEncargo, true);

        return perc
      },
      valorEncargos: function() {
        const valor = this.$options.filters.formatarNumero(this.solicitacao.salarioBruto, true);
        const perc = this.$options.filters.formatarNumero(this.solicitacao.percentualEncargo, true);

        return valor * perc / 100
      },
      totalContratacao: function() {
        const somaSalarioEncargo = this.valorEncargos + this.valorSalarioBruto
        
        return this.solicitacao.eventos.reduce((somatorio, item) => {
          const valor = this.$options.filters.formatarNumero(item.valorEstimado, true);

          return somatorio + valor;
        }, somaSalarioEncargo);
      },
      is_celetista: function() {
        const tipo = this.$options.filters.formatarNumero(this.solicitacao.tipoSolicitacao, true);

        return tipo == 1;
      }
    },
    watch: {
      'solicitacao.aceite': 'removeErroAceite',
    }
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xs-2">
      </div>
      <div class="col-xs-8">
        <div class="table-responsive">
          <table class="table table-bordered table-column-code table-column-action">
            <thead>
              <tr>
                <th colspan="3">Tabela - Custo Contratação</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td>A) Salário bruto previsto</td>
                <td style="text-align: right; width: 200px;">R$ {{ valorSalarioBruto | formatarNumero }}</td>
              </tr>
              <tr v-if="is_celetista">
                <td></td>
                <td>B) Encargos {{ percentualEncargo | formatarNumero }}%</td>
                <td style="text-align: right;">R$ {{ valorEncargos | formatarNumero }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ retornaBC() }}) Benefícios</td>
                <td></td>
              </tr>
              <tr v-for="(evento, index) in solicitacao.eventos">
                <td></td>
                <td>{{ retornaBC() }}{{index + 1}}) {{evento.solicitacaoContratacaoPessoalEvento.descricao}}</td>
                <td style="text-align: right;">R$ {{ evento.valorEstimado }}</td>
              </tr>
            </tbody>
            <tfoot style="background: #e7eaec82; font-weight: 600;">
              <tr>
                <td></td>
                <td>{{ retornaCD() }}) Custo total para o projeto (mês)</td>
                <td style="text-align: right;">R$ {{ totalContratacao | formatarNumero }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="col-xs-2">
      </div>
    </div>

    <div class="row" v-if="!relatorio">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('aceite')}">
          <div class="checkbox">
            <checkbox v-model="solicitacao.aceite" value="1" type="primary">
              Revisei e aceito o custo total para o projeto (mês)
            </checkbox>
          </div>

          <p class="text-danger" v-show="errors.has('aceite')">{{ errors.first('aceite') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-contratacao-pessoal/componentes/compartilhado/FormResumoEventos.vue